import React from "react";
import warning from "../../assets/warning.svg";

const NoConfirmVSView = ({ treeType, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 w-screen h-screen flex justify-center items-center font-inter">
      <div className="bg-white rounded-[10px] px-[57px] flex flex-col justify-center items-center gap-4 py-[50px]">
        <img src={warning} alt="" className="" />
        <p className="font-[550] text-center leading-5 mt-[13px] mb-[25px]">{`Let's set up the "${treeType}".`}</p>
        <button
          className="bg-[#55C880] px-5 py-[7px] mb-4 rounded-[10px] text-white"
          onClick={() => onClose(treeType)}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default NoConfirmVSView;
